import React, { useState, useEffect } from 'react';
import socket from '../socket';
import RegionSelect from './RegionSelect';

const ALL_REGION_KEYS = ['kanto', 'johto', 'hoenn', 'sinnoh', 'unova', 'kalos', 'alola', 'galar', 'paldea'];

function Lobby() {
  const [playerName, setPlayerName] = useState('');
  const [roomCode, setRoomCode] = useState('');
  const [joinCode, setJoinCode] = useState('');
  const [waiting, setWaiting] = useState(false);
  const [error, setError] = useState('');
  const [selectedRegions, setSelectedRegions] = useState([...ALL_REGION_KEYS]);
  const [boardSize, setBoardSize] = useState(24);

  useEffect(() => {
    socket.on('room-created', ({ roomCode }) => {
      setRoomCode(roomCode);
      setWaiting(true);
    });

    socket.on('join-error', ({ error }) => {
      setError(error);
    });

    return () => {
      socket.off('room-created');
      socket.off('join-error');
    };
  }, []);

  const handleCreate = () => {
    if (!playerName.trim()) return;
    if (selectedRegions.length === 0) {
      setError('Please select at least one region');
      return;
    }
    setError('');
    socket.emit('create-room', {
      playerName: playerName.trim(),
      regions: selectedRegions,
      boardSize,
    });
  };

  const handleJoin = () => {
    if (!playerName.trim() || !joinCode.trim()) return;
    setError('');
    socket.emit('join-room', {
      roomCode: joinCode.trim().toUpperCase(),
      playerName: playerName.trim(),
    });
  };

  if (waiting) {
    return (
      <div className="lobby">
        <h1 className="lobby-title">Pokemon Guess Who</h1>
        <div className="lobby-card">
          <h2>Waiting for opponent...</h2>
          <div className="room-code-display">
            <p>Share this code:</p>
            <span className="room-code">{roomCode}</span>
          </div>
          <div className="waiting-spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="lobby">
      <h1 className="lobby-title">Pokemon Guess Who</h1>
      <div className="lobby-card">
        <div className="input-group">
          <label>Your Name</label>
          <input
            type="text"
            value={playerName}
            onChange={(e) => setPlayerName(e.target.value)}
            placeholder="Enter your name"
            maxLength={16}
          />
        </div>

        {error && <p className="error-message">{error}</p>}

        <div className="lobby-actions">
          <div className="action-section">
            <RegionSelect
              selectedRegions={selectedRegions}
              onRegionsChange={setSelectedRegions}
              boardSize={boardSize}
              onBoardSizeChange={setBoardSize}
            />
            <button
              type="button"
              className="btn btn-create"
              onClick={handleCreate}
              onTouchEnd={(e) => { e.preventDefault(); handleCreate(); }}
            >
              Create Room
            </button>
          </div>

          <div className="divider">or</div>

          <div className="action-section">
            <input
              type="text"
              value={joinCode}
              onChange={(e) => setJoinCode(e.target.value.toUpperCase())}
              placeholder="Room code"
              maxLength={4}
              className="code-input"
            />
            <button
              type="button"
              className="btn btn-join"
              onClick={handleJoin}
              onTouchEnd={(e) => { e.preventDefault(); handleJoin(); }}
            >
              Join Room
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Lobby;
